const _excluded = ["attribute", "searchable", "searchablePlaceholder", "showMore", "showMoreButton", "showMoreText", "showLessText", "className", "itemClassName"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useRefinementList } from 'react-instantsearch';
import { Button as RKSButton, FormCheckboxes } from '@uncinc/uncinc-react-kitchen-sink';
import SearchBarBase from '../../SearchBar/Base';
import { DEFAULT_TEXT } from '../../../config/constants';
import './style.scss';
const SearchFacetRefinementCheckboxes = props => {
  const {
    t
  } = useTranslation();
  const {
      attribute,
      searchable,
      searchablePlaceholder,
      showMore,
      showMoreButton,
      showMoreText = t(['searchkit.buttons.show_more', DEFAULT_TEXT.BUTTONS.SHOW_MORE]),
      showLessText = t(['searchkit.buttons.show_less', DEFAULT_TEXT.BUTTONS.SHOW_LESS]),
      className,
      itemClassName
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  const {
    items,
    canToggleShowMore,
    isShowingMore,
    canRefine,
    searchForItems,
    toggleShowMore,
    refine
  } = useRefinementList(props);
  const classNames = c('Searchkit__Facet__RefinementCheckboxes', className);
  const itemClassNames = c('Searchkit__Facet__RefinementCheckboxes__item', itemClassName);
  const Button = showMoreButton || RKSButton;
  const fieldName = "refinementList_".concat(attribute);
  const options = items.map(item => ({
    value: item.value,
    label: /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label",
      "data-facet-label": item.label,
      "data-facet-count": item.count
    }, /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__label"
    }, item.label), /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__count"
    }, item.count)),
    disabled: item.count === 0
  }));
  if (!canRefine) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "Searchkit__Facet__RefinementCheckboxes__wrapper"
  }, /*#__PURE__*/React.createElement(FormCheckboxes, _extends({}, restProps, {
    fieldName: fieldName,
    options: options,
    wrapperClassName: classNames,
    className: itemClassNames,
    onChange: value => {
      refine(value);
    }
  })), searchable && /*#__PURE__*/React.createElement(SearchBarBase, {
    placeholder: searchablePlaceholder,
    autoSearch: true,
    className: "Searchkit__Facet__RefinementCheckboxes__searchbar",
    onSubmit: query => {
      searchForItems(query);
    }
  }), showMore && canToggleShowMore && /*#__PURE__*/React.createElement(Button, {
    className: "Searchkit__Facet__RefinementCheckboxes__showMore",
    onClick: () => {
      toggleShowMore();
    }
  }, isShowingMore ? showLessText : showMoreText));
};
export default SearchFacetRefinementCheckboxes;